import React, { FC } from 'react';
import FavouriteButton from '#components/controls/buttons/favouriteButton/FavouriteButton';
import Link from 'next/link';
import s from '#components/teaser-details/TeaserDetails.module.scss';
import ButtonPlayRounded from '#components/controls/buttons/buttonPlayRounded/ButtonPlayRounded';
import { useOvermindActions, useOvermindState } from '#store/overmind';
import { getRoute } from '#utils';
import { useGetTeaserQuery } from '#types/generated/apollo-client';
import { ContentType, LivestreamState } from '#types/generated/graphql-types';
import TeaserDetailsMediaInfos from '#components/teaser-details/TeaserDetailsMediaInfos';
import TeaserDetailsLivestreamInfos from '#components/teaser-details/TeaserDetailsLivestreamInfos';
import LiveIndicator from '#components/feedback/live-indicator/LiveIndicator';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  iri: string;
};

const TEASER_DEFAULT_TYPES = ['Studio', 'Media', 'Series'];

const TeaserDetails: FC<Props> = ({ iri }) => {
  const { hideDetails } = useOvermindActions().teaserDetails;
  const { isLoggedIn } = useOvermindState().user;
  const { t } = useTranslation();

  const { data: detailedData } = useGetTeaserQuery({
    variables: {
      path: iri,
    },
  });

  const handleOnMouseLeave = () => {
    hideDetails();
  };

  //exclude category teasers
  if (detailedData?.teaser?.__typename === 'Category') {
    return null;
  }

  return (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    <div
      className={`tw-rounded-xl tw-overflow-hidden tw-shadow-md ${s.host} ${
        !detailedData?.teaser ? 'tw-pointer-events-none' : ''
      }`}
      role="button"
      onMouseLeave={handleOnMouseLeave}
    >
      <div className="tw-flex tw-flex-col tw-cursor-pointer">
        <div className={s.media}>
          {!!detailedData?.teaser?.teaserImageFormats?.sixteenByNine
            ?.medium && (
            <Link href={getRoute(detailedData?.teaser, t) || ''}>
              <img
                alt={detailedData?.teaser?.title}
                src={
                  detailedData.teaser.teaserImageFormats.sixteenByNine.medium
                }
                width={380}
                height={213}
              />
            </Link>
          )}
          {detailedData?.teaser?.['__typename'] === 'Media' && (
            <>
              {detailedData?.teaser?.contentType !== ContentType.LiveStream && (
                <div className="tw-absolute tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 tw-flex tw-items-center tw-pointer-events-none">
                  <ButtonPlayRounded />
                </div>
              )}
              {detailedData?.teaser?.details?.streamState ===
                LivestreamState.Live && (
                <LiveIndicator classes="tw-absolute tw-top-4 tw-left-4" />
              )}
            </>
          )}
          {!!detailedData?.teaser && isLoggedIn && (
            <FavouriteButton
              item={{ iri }}
              isSizeSmall
              classes="tw-absolute tw-top-4 tw-left-4"
            />
          )}
        </div>
        <Link href={getRoute(detailedData?.teaser, t) || ''}>
          <div className="tw-min-h-[162px] tw-p-4">
            {TEASER_DEFAULT_TYPES.includes(
              detailedData?.teaser?.['__typename']
            ) &&
              detailedData?.teaser?.contentType !== ContentType.LiveStream && (
                <TeaserDetailsMediaInfos teaserData={detailedData?.teaser} />
              )}

            {detailedData?.teaser?.['__typename'] === 'Media' &&
              detailedData?.teaser?.contentType === ContentType.LiveStream && (
                <TeaserDetailsLivestreamInfos
                  teaserData={detailedData?.teaser}
                />
              )}
          </div>
        </Link>
      </div>
    </div>
  );
};

export default TeaserDetails;
